<template>
  <div>
    <div class="res-assignment-card">
      <div class="d-flex gap">
        <AssignmentLink/>
        <Importance :importance="responsibilityImportance" />
        <ExNewBadgeVue v-if="showNewBadge"/>
        <Icon name="org_icon_responsibility"/>
        <div class="responsibility-text">
          <span v-if="show_codes">{{ responsibilityCode }}</span>
          <span class="name">
            {{ responsibilityName }}
          </span>
        </div>
      </div>
      <div class="d-flex gap ms-4 role-item">
        <Icon name="new_line_pointer_icon" class="line-pointer"/>
        <Importance :importance="roleImportance" :type="false" />
        <AssignmentLink class="change-width" />
        <div class="role-text" v-if="show_codes">{{ roleCode }}</div>
        <Icon name="org_icon_role" class="roleIcon"/>
        <div class="role-text"><span class="roleName">{{ roleName }}</span></div>
      </div>
      <div class="d-flex gap ms-9 position-item">
        <Icon name="new_line_pointer_icon" class="line-pointer1"/>
        <Importance :importance="positionImportance" :type="false" />
        <AssignmentLink class="change-width" />
        <div class="position-text" v-if="show_codes">{{ positionCode }}</div>
        <Icon name="org_icon_position" class="posIcon"/>
        <AsEmployeeCommitmentCard class="pos-commit" :commitment="positionCommitment" :labelShow="false" />
        <div class="position-text"><span class="posName">{{ positionName }}</span></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import Icon from "@components/icons/Icon.vue";
import AssignmentLink from "@components/AssignmentLink/AssignmentLink";
import Importance from '@components/importance/Importance.vue';
import ExNewBadgeVue from "@components/ExNewBadge/ExNewBadge.vue";
import AsEmployeeCommitmentCard from "@components/AsEmployeeCommitmentCard/AsEmployeeCommitmentCard";

const props = defineProps({
  responsibilityCode: {
    type: String,
    default: "#9999",
  },
  responsibilityName: {
    type: String,
    default: "Responsibility Name",
  },
  roleCode: {
    type: String,
    default: "#245",
  },
  roleName: {
    type: String,
    default: "Implement CAPEX initiatives",
  },
  positionCode: {
    type: String,
    default: "#4567",
  },
  positionName: {
    type: String,
    default: "General Manager",
  },
  responsibilityImportance: {
    type: Number,
    default: 0,
  },
  roleImportance: {
    type: Number,
    default: 0,
  },
  positionImportance: {
    type: Number,
    default: 0,
  },
  positionCommitment: {
    type: String,
    default: "Primary",
  },
  assignedOn: {
    type: Date,
    default: () => new Date("2025-09-01")
  },
  newDuration: {
    type: Number,
    default: 15,
  },
  show_codes: {
    type: Boolean,
    default: false,
  }
});

const showNewBadge = computed(() => {
  const today = new Date();
  const todayPlusDuration = new Date();
  todayPlusDuration.setDate(today.getDate() + props.newDuration);
  const assignedDate = new Date(props.assignedOn);
  return assignedDate < todayPlusDuration;
});
</script>

<style>
.res-assignment-card .importance-container {
  height: 22px !important;
}
.res-assignment-card .role-item .importance-container {
  height: 18px !important;
  margin-top: 1px;
  margin-left: -2px;
}
.res-assignment-card .position-item .importance-container {
  height: 18px !important;
  margin-top: 1px;
  margin-left: -2px;
}
.res-assignment-card .role-item .importance-container .bar {
  min-width: 5px !important;
  margin-left: 1px !important;
}
.res-assignment-card .position-item .importance-container .bar {
  min-width: 5px !important;
  margin-left: 1px !important;
}
.res-assignment-card .badge-box {
  height: 24px;
  margin-top: -1px;
  padding: 3px 6px !important;
}
.res-assignment-card .line-pointer {
  margin-left: -6px;
  margin-top: 8px;
}
.res-assignment-card .line-pointer1 {
  margin-left: -2px;
  margin-top: 8px;
}
.res-assignment-card .as-employee-com {
  padding: 0px !important;
  margin-top: -6px;
  margin-left: -2px;
  margin-right: -2px;
}
.res-assignment-card .as-employee-com .employee-lbl-icon {
  padding: 0px !important;
}
.res-assignment-card .responsibility-text {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #475467;
  margin-bottom: 4px;
}
.res-assignment-card .responsibility-text .name {
  font-weight: 500;
  color: #101828;
}
.res-assignment-card .role-text {
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #475467;
  margin-bottom: 4px;
}
.res-assignment-card .role-text .roleName {
  font-weight: 500;
  color: #101828;
}
.res-assignment-card .position-text {
  font-family: Inter;
  font-size: 10px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #475467;
}
.res-assignment-card .position-text .posName {
  font-weight: 500;
  color: #101828;
}
.res-assignment-card .gap {
  gap: 7px;
}
.res-assignment-card .responsibility-sec {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
}
.res-assignment-card .responsibility-sec .resp-code {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #475467;
}
.res-assignment-card .responsibility-sec .resp-name {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #101828;
}
.res-assignment-card .roleIcon {
  width: 16px;
}
.res-assignment-card .posIcon {
  width: 16px;
}
.res-assignment-card .change-width svg {
  width: 16px;
  height: 16px;
  margin-top: 4px;
}
.res-assignment-card .pos-commit svg {
  width: 18px;
  height: 18px;
  margin-top: 2px;
}
</style>